import { useEffect, useRef } from "react";
import { API_DATE_FORMAT } from "src/consts/global";

const useLoadTeamDataById = (loadTeamDataById, teamId, state) => {
  const prevFromDate = useRef(state?.viewOptions?.fromDate);
  const prevToDate = useRef(state?.viewOptions?.toDate);

  useEffect(() => {
    loadTeamDataById(teamId, teamId);
    /**
     * HACK: This is a hack to load the team data when the teamId changes between page changes.
     * If I add loadTeamDataById to the dependencies, it will cause an infinite loop.
     * It works like this so don't touch it otherwise it will break the org chart.
     *  */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teamId]);

  useEffect(() => {
    if (
      (prevFromDate.current?.format(API_DATE_FORMAT) &&
        prevToDate.current?.format(API_DATE_FORMAT) &&
        prevFromDate.current?.format(API_DATE_FORMAT) !==
          state?.viewOptions?.fromDate?.format(API_DATE_FORMAT)) ||
      prevToDate.current?.format(API_DATE_FORMAT) !==
        state?.viewOptions?.toDate?.format(API_DATE_FORMAT) ||
      (prevFromDate.current?.format(API_DATE_FORMAT) &&
        prevToDate.current?.format(API_DATE_FORMAT) &&
        !state?.viewOptions?.fromDate &&
        !state?.viewOptions?.toDate)
    ) {
      prevFromDate.current = state?.viewOptions?.fromDate;
      prevToDate.current = state?.viewOptions?.toDate;
      loadTeamDataById(teamId, teamId);
    }
    /**
     * HACK: This is a hack to load the team data when the teamId changes between page changes.
     * If I add loadTeamDataById to the dependencies, it will cause an infinite loop.
     * It works like this so don't touch it otherwise it will break the org chart.
     *  */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.viewOptions?.fromDate, state?.viewOptions?.toDate]);
};

export default useLoadTeamDataById;
